import React, { useState } from "react";
import ChatBot from "./Pages/chatbot";
import SmartwatchDemo from "./Pages/smartwatch";
import LocationAwareBlueDotMap from "./Pages/location-map";
import PatientSceneSetter from "./Pages/patient-experience";
import ClinicalWorkflowCanvas from "./Pages/clinical-canvas";
import RFPAutoResponder from "./Pages/rfp-autoresponder";
import ConnexallMarketplace from "./Pages/marketplace";

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

const Router: React.FC = () => {
  const [currentPage, setCurrentPage] = useState("chatbot");

  const button = (page: string) => (
    <button
      className={`${
        currentPage === page
          ? "bg-blue-600 text-white"
          : "bg-gray-200 text-gray-600"
      } px-4 py-2 rounded-lg`}
      onClick={() => setCurrentPage(page)}
    >
      {capitalize(page.replace("-", " "))}
    </button>
  );

  const buttons = () => (
    <div className="flex flex-row space-x-4 m-2">
      {button("chatbot")}
      {button("smartwatch")}
      {button("location-map")}
      {button("patient-scene")}
      {button("clinical-canvas")}
      {button("rfp-autoresponder")}
      {button("marketplace")}
    </div>
  );

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {buttons()}
      {currentPage === "chatbot" && <ChatBot />}
      {currentPage === "smartwatch" && <SmartwatchDemo />}
      {currentPage === "location-map" && <LocationAwareBlueDotMap />}
      {currentPage === "patient-scene" && <PatientSceneSetter />}
      {currentPage === "clinical-canvas" && <ClinicalWorkflowCanvas />}
      {currentPage === "rfp-autoresponder" && <RFPAutoResponder />}
      {currentPage === "marketplace" && <ConnexallMarketplace />}
    </div>
  );
};

export default Router;
